<template>
    <card-component title="INGRESE SU CONTRASEÑA" icon="cellphone" :has-card-header-background="true" :has-button-slot="true">
      <form @submit.prevent="submit" method="POST">
        <b-field label="CONTRASEÑA" >
          <b-input v-model="passw" name="passw" required autofocus/>
        </b-field>
        <small><p v-if="!isPasswordValid">La contraseña debe tener al menos 8 caracteres, contener letras mayúsculas y minúsculas y un número</p></small>
        <br>
        <b-field label="VERIFICA TU CONTRASEÑA" >
          <b-input v-model="passwConfirm" name="passwConfirm" required autofocus/>
        </b-field>
        <small><p v-if="!passwordMatches">La contraseñas no coinciden.</p></small>
        <hr>
        <div class="control">
          <b-button  class="button is-primary" expanded @click="openModal('isImageModalActive')">
            Aceptar
          </b-button>
        </div>
      </form>
      <b-modal :active.sync="isImageModalActive" has-modal-card>
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <b-icon
                  icon="exclamation-thick"
                  size="is-small">
              </b-icon>
              <p class="modal-card-title">¡MUY IMPORTANTE!:</p>
              <button
                  type="button"
                  class="delete"
                  @click="openModal('isImageModalActive')"/>
          </header>
          <section class="modal-card-body">
            <p>
                Ingresa a Workplace y vuelve a escribir tu contraseña para activar tu cuenta.
            </p>
          </section>
          <footer class="modal-card-foot is-flex justify-content-end">
              <b-button
                  @click="savePhoneNumber"
                  label="OK"
                  type="is-primary" />
          </footer>
        </div>
      </b-modal>
    </card-component>
  </template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import PhoneRepository from '@/services/PhoneRepository'
import TokenRepository from '@/services/TokenRepository'

export default {
  name: 'EnterPassword',
  components: { CardComponent },
  data () {
    return {
      isImageModalActive: false,
      passw: null,
      passwConfirm: null
    }
  },
  mounted () {
  },
  computed: {
    ...mapState([
      'idUser',
      'phoneNumber'
    ]),
    isPasswordValid () {
      const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
      return regex.test(this.passw)
    },
    passwordMatches () {
      return this.passw === this.passwConfirm
    }
  },
  created () {
    if (this.idUser === null) {
      this.$router.push('/start-claim')
    }
  },
  methods: {
    openModal (modalName) {
      if (!(this.passwordMatches && this.isPasswordValid)) {
        return
      }
      console.log('Se hizo clic en el botón Activar Cuenta')
      this[modalName] = !this[modalName]
      console.log(this[modalName])
      console.log(this.phone)
    },
    closeModal () {
      this.isImageModalActive = !this.isImageModalActive
      console.log(this.isImageModalActive)
    },
    requestToken (data) {
      TokenRepository.requestTokenSMS(this.idUser, data)
        .then((r) => {
          this.isLoading = false
          this.$store.commit('removeIDUser')
          window.location.replace(r.data.url_to_claim)
        }).catch(e => {
          this.isLoading = false
          this.showError(e.response.data.detail)
        })
    },
    savePhoneNumber () {
      this.isLoading = true
      console.log(this.phone)
      PhoneRepository.savePhoneNumber(
        this.idUser, { phone_number: this.phoneNumber }
      ).then((r) => {
        // Here we re direct!
        console.log('entro')
        console.log(r.data)
        this.requestToken(r.data)
      }).catch(e => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: `Error: ${e.response.data.detail}`,
          type: 'is-danger'
        })
      })
    }
    // async copyPassword () {
    //   if (!this.passw) {
    //     alert("There's no password to copy.")
    //     return
    //   }

    //   try {
    //     await navigator.clipboard.writeText(this.passw)
    //     alert('Password copied to clipboard!')
    //   } catch (err) {
    //     console.error('Failed to copy: ', err)
    //     alert('Failed to copy the password to clipboard.')
    //   }
    // }
  }
}
</script>
